import { render, staticRenderFns } from "./RequestNewAnswer.vue?vue&type=template&id=6c9ce2dd&scoped=true&"
import script from "./RequestNewAnswer.vue?vue&type=script&lang=js&"
export * from "./RequestNewAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9ce2dd",
  null
  
)

export default component.exports